<template>
  <div class="animated fadeIn list-of-ap">
    <b-card v-if="showForm == false">
      <div slot="header">Timesheet
        <div class="card-header-actions mt-0 mb-0">
          <b-button variant="primary mr-1" @click="compileShow = true"><i class="fa fa-exchange"></i> Modul
            Roster</b-button>
          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="showUploadFrm = true"><i class="fa fa-cloud-upload"></i>
            Import/Upload</b-button>
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</b-button>
          <b-button variant="primary mr-1" @click="togleFilter()"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()"> <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row v-if="showFilter" class="ml-2 mr-2">
        <b-col lg=5>
          <b-input-group>
            <b-input-group-prepend><label style="width: 100px !important;">Project</label></b-input-group-prepend>
            <b-form-input readonly v-model="tblData.CustName"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuCustomerShow = true"><i class="fa fa-search"></i></b-btn>
            </b-input-group-append>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label style="width: 100px !important;">Employee</label></b-input-group-prepend>
            <b-form-input v-model="tblData.crewinfo" readonly></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuCrewShow = true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col lg="7">
          <b-input-group>
            <b-input-group-prepend><label>Periode Payroll</label></b-input-group-prepend>
            <vue-monthly-picker style="width:333px;" v-model="tblData.payrolldate" dateFormat="MMMM YYYY"
              :monthLabels="monthLabels"></vue-monthly-picker>
            <b-input-group-prepend><span class="ml-1 pt-2 mr-1">Over Time</span></b-input-group-prepend>
            <b-form-select v-model="tblData.overtime" :plain="true" :options="YesNoAll"></b-form-select>
            <b-input-group-prepend><span class="ml-1 pt-2 mr-1">Location</span></b-input-group-prepend>
            <b-form-input v-model="tblData.location" class="ml-1" placeholder="Location"
              style="width: 20% !important;"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Working Date</label></b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date"></b-form-input>
            <b-input-group-prepend><span class="input-group-text">-</span></b-input-group-prepend>
            <b-form-input v-model="tblData.tgl2" type="date"></b-form-input>
            <b-input-group-append>
              <b-button variant="success" size="sm" class="ml-2" @click="refresh()"> <i class="fa fa-refresh"></i> Apply
                Filter</b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilter()">Clear Filter</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-table class="mb-0 text-nowrap" ref="table" outlined responsive striped hover style="font-size:smaller;"
        :items="data" :fields="tblFields" :current-page="tblData.page" :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy" :sort-desc.sync="tblData.sortDesc" :key="tblData.limit" @row-clicked="rowClicked">
        <template v-slot:cell(payrolldate)="data">
          {{ data.item.payrolldate | moment("MMM YYYY") }}
        </template>
        <template v-slot:cell(tanggal)="data">
          {{ data.item.tanggal | moment("ddd, DD MMM YYYY") }}
        </template>
      </b-table>
      <b-row>
        <b-col cols="5">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
            to <span v-if="((tblData.page * tblData.limit) > tblData.total)">{{ tblData.total }}</span> <span
              v-else>{{ tblData.page * tblData.limit }}</span>
            of {{ tblData.total }} entries
          </div>
        </b-col>
        <b-col cols="2">
          <b-input-group>
            <b-input-group-prepend><span class="pt-1 mr-2">Limit per page</span></b-input-group-prepend>
            <b-form-select :options="[10, 15, 20, 25]" :plain="true" v-model="tblData.limit" size="sm"
              style="width:80px;" />
          </b-input-group>
        </b-col>
        <b-col cols="5">
          <b-pagination align="right" :total-rows="tblData.total" :per-page="tblData.limit"
            v-model="tblData.page"></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <b-row class="justify-content-center" v-if="showForm == true">
      <b-col lg="10" xl="8">
        <b-card>
          <div slot="header">Timesheet - Add/Edit Form </div>
          <b-row no-gutters>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend><label>Employee</label></b-input-group-prepend>
                <b-form-input v-model="model.crewinfo" readonly :state="!$v.model.crewkey.$error"></b-form-input>
                <b-input-group-append>
                  <b-btn text="Button" @click="lkuCrewShow = true">
                    <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col lg="5">
              <b-input-group>
                <b-input-group-append><label class="input-group-text ml-3" style="font-weight: bolder;">Working Date
                  </label></b-input-group-append>
                <b-form-input v-model="model.tanggal" type="date" :state="!$v.model.tanggal.$error"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="3">
              <b-input-group>
                <b-input-group-prepend><label>Status Hadir</label></b-input-group-prepend>
                <b-form-select v-model="model.HARI_HADIR" :plain="true" :options="YesNo"
                  :state="!$v.model.HARI_HADIR.$error"></b-form-select>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend><label>Status izin</label></b-input-group-prepend>
                <b-form-select v-model="model.HARI_IZIN" :plain="true" :options="YesNo"
                  :state="!$v.model.HARI_IZIN.$error"></b-form-select>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend><label>Status Sakit</label></b-input-group-prepend>
                <b-form-select v-model="model.HARI_SAKIT" :plain="true" :options="YesNo"
                  :state="!$v.model.HARI_SAKIT.$error"></b-form-select>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend><label>Status Alpa(TK) </label></b-input-group-prepend>
                <b-form-select v-model="model.HARI_ALPA" :plain="true" :options="YesNo"
                  :state="!$v.model.HARI_ALPA.$error"></b-form-select>
              </b-input-group>
            </b-col>
            <b-col lg="4">
              <b-input-group>
                <b-input-group-prepend><label>Status BKO</label></b-input-group-prepend>
                <b-form-select v-model="model.HARI_BKO" :plain="true" :options="YesNo"
                  :state="!$v.model.HARI_BKO.$error"></b-form-select>
                <b-input-group-prepend><span class="input-group-text"> Replacement Team </span></b-input-group-prepend>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend><label>Status OOT</label></b-input-group-prepend>
                <b-form-select v-model="model.HARI_OOT" :plain="true" :options="YesNo"
                  :state="!$v.model.HARI_OOT.$error"></b-form-select>
                <b-input-group-prepend><span class="input-group-text"> Off Overtime </span></b-input-group-prepend>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend><label>Jumlah Jam Kerja</label></b-input-group-prepend>
                <b-form-input v-model="model.JAM_KERJA" type="number" :state="!$v.model.JAM_KERJA.$error"></b-form-input>
                <b-input-group-prepend><span class="input-group-text"> termasuk jam Istirahat
                  </span></b-input-group-prepend>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend><label>Jumlah Jam OT</label></b-input-group-prepend>
                <b-form-input v-model="model.JAM_OT" type="number" :disabled="model.overtimeable == 0"></b-form-input>
                <b-input-group-prepend><span class="input-group-text ml-2">dlm INDEX</span></b-input-group-prepend>
                <b-form-input v-model="model.INDEX_OT"></b-form-input>
              </b-input-group>
              <!-- <b-input-group>
                        <b-input-group-prepend ><label>Status Kemahalan </label></b-input-group-prepend>
                        <b-form-select v-model="model.HARI_MAHAL" :plain="true" :options="YesNo" ></b-form-select>                              
                        <b-input-group-prepend ><span class="input-group-text" > Tunj. daerah terpencil </span></b-input-group-prepend>
                    </b-input-group> -->
            </b-col>
            <b-col lg="5">
              <b-input-group>
                <b-input-group-prepend><label>Uraian/Keterangan</label></b-input-group-prepend>
                <b-form-textarea id="alamatwp" v-model="model.uraian" rows="4" max-rows="6"></b-form-textarea>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend><label>Payroll Date</label></b-input-group-prepend>
                <vue-monthly-picker style="width:333px;" v-model="model.payrolldate" :state="!$v.model.payrolldate.$error"
                  dateFormat="MMMM YYYY" :monthLabels="monthLabels"></vue-monthly-picker>
              </b-input-group>
            </b-col>

          </b-row>

          <div slot="footer" style="text-align:center;">
            <button class="btn btn-primary mr-1" @click="save()">
              <i class="fa fa-save"></i> Save
            </button>
            <b-button variant="secondary" class="mr-1" @click="showForm = false"> <i class="fa fa-close"></i> Close
              Form</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-modal v-model="compileShow" header-bg-variant="primary" title="Get Timesheet from Module Roster" size="md"
      :centered="true" @ok="compile" ok-title="Process Now">
      <b-input-group>
        <b-input-group-prepend><label>Payroll Period</label></b-input-group-prepend>
        <vue-monthly-picker style="width:333px;" v-model="compilePeriode" :state="!(!(compilePeriode))"
          dateFormat="MMMM YYYY" :monthLabels="monthLabels"></vue-monthly-picker>
      </b-input-group>
      <span class="text-muted mt-2">
        Process bisa dilakukan lebih dari sekali, sistem akan mengUpdate data berdasarkan proses yg terakhir dg NIK dan
        Tanggal sebagai KEY/ID
      </span>

    </b-modal>

    <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
      <p class="mb-1">1 record is about to be permanently deleted</p>
      <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
    </b-modal>

    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal v-model="showReport" size="lg" title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>

    <b-modal v-model="showUploadFrm" header-bg-variant="primary" size="lg" title="Import/Upload TIMESHEET"
      :centered="true" @ok="handleOk" ok-title="Process">
      <b-form @submit.stop.prevent="uploadinv">
        <b-tabs v-model="tabIndex" card>
          <b-tab title="Version #1">
            <b-card class="ColsDefine">
              <strong>Define Excel Column name for each TIMESHEET fields</strong>
              <b-row class="ml-2 mr-2">
                <b-col lg="3">
                  <b-input-group>
                    <b-input-group-prepend><label>NIK (Badge No.)</label></b-input-group-prepend>
                    <b-form-select v-model="frmupload1.crewnik" :plain="true" :options="kolomXls"
                      :state="!$v.frmupload1.crewnik.$error"></b-form-select>
                  </b-input-group>
                  <b-input-group>
                    <b-input-group-prepend><label>Nama</label></b-input-group-prepend>
                    <b-form-select v-model="frmupload1.crewname" :plain="true" :options="kolomXls"
                      :state="!$v.frmupload1.crewname.$error"></b-form-select>
                  </b-input-group>
                  <b-input-group>
                    <b-input-group-prepend><label>Tanggal</label></b-input-group-prepend>
                    <b-form-select v-model="frmupload1.tanggal" :plain="true" :options="kolomXls"
                      :state="!$v.frmupload1.tanggal.$error"></b-form-select>
                  </b-input-group>
                  <b-input-group>
                    <b-input-group-prepend><label>Jam Kerja</label></b-input-group-prepend>
                    <b-form-select v-model="frmupload1.JAM_KERJA" :plain="true" :options="kolomXls"
                      :state="!$v.frmupload1.JAM_KERJA.$error"></b-form-select>
                  </b-input-group>
                </b-col>
                <b-col lg="3">
                  <b-input-group>
                    <b-input-group-prepend><label>Status Hadir</label></b-input-group-prepend>
                    <b-form-select v-model="frmupload1.HARI_HADIR" :plain="true" :options="kolomXls"
                      :state="!$v.frmupload1.HARI_HADIR.$error"></b-form-select>
                  </b-input-group>
                  <b-input-group>
                    <b-input-group-prepend><label>Status izin</label></b-input-group-prepend>
                    <b-form-select v-model="frmupload1.HARI_IZIN" :plain="true" :options="kolomXls"
                      :state="!$v.frmupload1.HARI_IZIN.$error"></b-form-select>
                  </b-input-group>
                  <b-input-group>
                    <b-input-group-prepend><label>Status Sakit</label></b-input-group-prepend>
                    <b-form-select v-model="frmupload1.HARI_SAKIT" :plain="true" :options="kolomXls"
                      :state="!$v.frmupload1.HARI_SAKIT.$error"></b-form-select>
                  </b-input-group>
                  <b-input-group>
                    <b-input-group-prepend><label>Status Alpa(TK) </label></b-input-group-prepend>
                    <b-form-select v-model="frmupload1.HARI_ALPA" :plain="true" :options="kolomXls"
                      :state="!$v.frmupload1.HARI_ALPA.$error"></b-form-select>
                  </b-input-group>
                </b-col>
                <b-col lg="3">
                  <b-input-group>
                    <b-input-group-prepend><label>status BKO</label></b-input-group-prepend>
                    <b-form-select v-model="frmupload1.HARI_BKO" :plain="true" :options="kolomXls"
                      :state="!$v.frmupload1.HARI_BKO.$error"></b-form-select>
                  </b-input-group>
                  <b-input-group>
                    <b-input-group-prepend><label>status OOT</label></b-input-group-prepend>
                    <b-form-select v-model="frmupload1.HARI_OOT" :plain="true" :options="kolomXls"
                      :state="!$v.frmupload1.HARI_OOT.$error"></b-form-select>
                  </b-input-group>
                  <b-input-group>
                    <b-input-group-prepend><label>Jumlah Jam OT</label></b-input-group-prepend>
                    <b-form-select v-model="frmupload1.JAM_OT" :plain="true" :options="kolomXls"
                      :state="!$v.frmupload1.JAM_OT.$error"></b-form-select>
                  </b-input-group>
                  <b-input-group>
                    <b-input-group-prepend><label>Uraian/Keterangan</label></b-input-group-prepend>
                    <b-form-select v-model="frmupload1.uraian" :plain="true" :options="kolomXls"
                      :state="!$v.frmupload1.JAM_OT.$error"></b-form-select>
                  </b-input-group>
                  <!-- <b-input-group>
                        <b-input-group-prepend ><label>Status Tj.Kemahalan </label></b-input-group-prepend>
                        <b-form-select v-model="frmupload1.HARI_MAHAL" :plain="true" :options="kolomXls" ></b-form-select>                              
                    </b-input-group>                     -->
                </b-col>
              </b-row>
              <b-input-group>
                <b-input-group-prepend><span class="pt-1 mr-1">Download :</span></b-input-group-prepend>
                <b-link @click="downloadtemplate" class="pt-1 ml-1"><i class="fa fa-paperclip"></i>
                  Template-timesheet.xlsx</b-link>
              </b-input-group>
            </b-card>
            <b-input-group>
              <b-input-group-prepend><label>Choose *.XLSX file</label></b-input-group-prepend>
              <b-form-file v-model="fileXlsx" :state="Boolean(fileXlsx)" placeholder="Choose a XLSX file..."
                drop-placeholder="Drop XLSX file here..."></b-form-file>
            </b-input-group>
            <b-row no-gutters>
              <b-col lg="6">
                <b-input-group>
                  <b-input-group-prepend><label>Nama SHEET </label></b-input-group-prepend>
                  <b-form-input v-model="frmupload1.sheetName" :state="!$v.frmupload1.sheetName.$error"></b-form-input>
                </b-input-group>
              </b-col>
              <b-col lg="3">
                <b-input-group>
                  <b-input-group-append><label class="input-group-text ml-1">Data mulai baris
                      ke-</label></b-input-group-append>
                  <b-form-input v-model="frmupload1.startRow" type="number"
                    :state="!$v.frmupload1.startRow.$error"></b-form-input>
                </b-input-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="6">
                <b-input-group>
                  <b-input-group-prepend><label>Period / Month </label></b-input-group-prepend>
                  <vue-monthly-picker style="width:333px;" v-model="frmupload1.periode"
                    :state="!$v.frmupload1.periode.$error" dateFormat="MMMM YYYY"
                    :monthLabels="monthLabels"></vue-monthly-picker>
                </b-input-group>
                <div v-if="($v.frmupload1.periode.$dirty && !$v.frmupload1.periode.$anyError)"
                  style="text-align:right; color:red;">Period / Month is required</div>
              </b-col>
            </b-row>

          </b-tab>
          <b-tab title="Version #2">
            <b-card class="ColsDefine">
              <strong>Define Excel Column name for each TIMESHEET fields</strong>
              <b-row class="ml-2 mr-2">
                <b-col lg="3">
                  <b-input-group>
                    <b-input-group-prepend><label>NIK (Badge No.)</label></b-input-group-prepend>
                    <b-form-select v-model="frmupload0.crewnik" :plain="true" :options="kolomXls"
                      :state="!$v.frmupload0.crewnik.$error"></b-form-select>
                  </b-input-group>
                  <b-input-group>
                    <b-input-group-prepend><label>Nama</label></b-input-group-prepend>
                    <b-form-select v-model="frmupload0.crewname" :plain="true" :options="kolomXls"
                      :state="!$v.frmupload0.crewname.$error"></b-form-select>
                  </b-input-group>
                </b-col>
                <b-col lg="3">
                  <b-input-group>
                    <b-input-group-prepend><label>Tanggal Awal(26)</label></b-input-group-prepend>
                    <b-form-select v-model="frmupload0.tgl1" :plain="true" :options="kolomXls"
                      :state="!$v.frmupload0.tgl1.$error"></b-form-select>
                  </b-input-group>
                  <b-input-group>
                    <b-input-group-prepend><label>Tanggal Akhir(25)</label></b-input-group-prepend>
                    <b-form-select v-model="frmupload0.tgl2" :plain="true" :options="kolomXls"
                      :state="!$v.frmupload0.tgl2.$error"></b-form-select>
                  </b-input-group>
                </b-col>
                <b-col lg="6">
                  <b-row no-gutters>
                    <b-col cols="6">
                      <b-input-group>
                        <b-input-group-prepend><label>Keterangan</label></b-input-group-prepend>
                        <b-form-select v-model="frmupload0.uraian" :plain="true" :options="kolomXls"></b-form-select>
                      </b-input-group>
                    </b-col>
                  </b-row>
                  <b-input-group>
                    <b-input-group-prepend><span class="pt-1 mr-1">Download :</span></b-input-group-prepend>
                    <b-link @click="downloadtemplate" class="pt-1 ml-1"><i class="fa fa-paperclip"></i>
                      Template-timesheet.xlsx</b-link>
                  </b-input-group>
                </b-col>
              </b-row>
            </b-card>
            <b-input-group>
              <b-input-group-prepend><label>Choose *.XLSX file</label></b-input-group-prepend>
              <b-form-file v-model="fileXlsx" :state="Boolean(fileXlsx)" placeholder="Choose a XLSX file..."
                drop-placeholder="Drop XLSX file here..."></b-form-file>
            </b-input-group>
            <b-row no-gutters>
              <b-col lg="6">
                <b-input-group>
                  <b-input-group-prepend><label>Nama SHEET </label></b-input-group-prepend>
                  <b-form-input v-model="frmupload0.sheetName" :state="!$v.frmupload0.sheetName.$error"></b-form-input>
                </b-input-group>
              </b-col>
              <b-col lg="3">
                <b-input-group>
                  <b-input-group-append><label class="input-group-text ml-1">Header Tanggal baris
                      ke</label></b-input-group-append>
                  <b-form-input v-model="frmupload0.headerRow" type="number"
                    :state="!$v.frmupload0.headerRow.$error"></b-form-input>
                </b-input-group>
              </b-col>
              <b-col lg="3">
                <b-input-group>
                  <b-input-group-append><label class="input-group-text ml-1">Data mulai baris
                      ke-</label></b-input-group-append>
                  <b-form-input v-model="frmupload0.startRow" type="number"
                    :state="!$v.frmupload0.startRow.$error"></b-form-input>
                </b-input-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="6">
                <b-input-group>
                  <b-input-group-prepend><label>Period / Month </label></b-input-group-prepend>
                  <vue-monthly-picker style="width:333px;" v-model="frmupload0.periode"
                    :state="!$v.frmupload0.periode.$error" dateFormat="MMMM YYYY"
                    :monthLabels="monthLabels"></vue-monthly-picker>
                </b-input-group>
                <div v-if="($v.frmupload0.periode.$dirty && !$v.frmupload0.periode.$anyError)"
                  style="text-align:right; color:red;">Period / Month is required</div>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab title="Version GREAT-DAY" active>
            <b-card class="ColsDefine">
              <strong>Define Excel Column name for each TIMESHEET fields</strong>
              <b-row class="ml-2 mr-2">
                <b-col lg="4">
                  <b-input-group>
                    <b-input-group-prepend><label>NIK (Badge No.)</label></b-input-group-prepend>
                    <b-form-select v-model="frmuploadGretDay.crewnik" :plain="true" :options="kolomXls"
                      :state="!$v.frmuploadGretDay.crewnik.$error"></b-form-select>
                  </b-input-group>
                  <b-input-group>
                    <b-input-group-prepend><label>Nama</label></b-input-group-prepend>
                    <b-form-select v-model="frmuploadGretDay.crewname" :plain="true" :options="kolomXls"
                      :state="!$v.frmuploadGretDay.crewname.$error"></b-form-select>
                  </b-input-group>
                  <b-input-group>
                    <b-input-group-prepend><label>Job Position</label></b-input-group-prepend>
                    <b-form-select v-model="frmuploadGretDay.crewname" :plain="true" :options="kolomXls"
                      :state="!$v.frmuploadGretDay.crewname.$error"></b-form-select>
                  </b-input-group>
                  <b-input-group>
                    <b-input-group-prepend><label>Department</label></b-input-group-prepend>
                    <b-form-select v-model="frmuploadGretDay.crewname" :plain="true" :options="kolomXls"
                      :state="!$v.frmuploadGretDay.crewname.$error"></b-form-select>
                  </b-input-group>
                </b-col>
                <b-col lg="4">
                  <b-input-group>
                    <b-input-group-prepend><label>Tanggal</label></b-input-group-prepend>
                    <b-form-select v-model="frmuploadGretDay.tanggal" :plain="true" :options="kolomXls"
                      :state="!$v.frmuploadGretDay.tanggal.$error"></b-form-select>
                  </b-input-group>
                  <b-input-group>
                    <b-input-group-prepend><label>Shift Code</label></b-input-group-prepend>
                    <b-form-select v-model="frmuploadGretDay.tanggal" :plain="true" :options="kolomXls"
                      :state="!$v.frmuploadGretDay.tanggal.$error"></b-form-select>
                  </b-input-group>
                  <b-input-group>
                    <b-input-group-prepend><label>Shift Start</label></b-input-group-prepend>
                    <b-form-select v-model="frmuploadGretDay.tanggal" :plain="true" :options="kolomXls"
                      :state="!$v.frmuploadGretDay.tanggal.$error"></b-form-select>
                  </b-input-group>
                  <b-input-group>
                    <b-input-group-prepend><label>Shift End</label></b-input-group-prepend>
                    <b-form-select v-model="frmuploadGretDay.tanggal" :plain="true" :options="kolomXls"
                      :state="!$v.frmuploadGretDay.tanggal.$error"></b-form-select>
                  </b-input-group>
                </b-col>
                <b-col lg="4">
                  <b-input-group>
                    <b-input-group-prepend><label>In</label></b-input-group-prepend>
                    <b-form-select v-model="frmuploadGretDay.timeIn" :plain="true" :options="kolomXls"
                      :state="!$v.frmuploadGretDay.timeIn.$error"></b-form-select>
                  </b-input-group>
                  <b-input-group>
                    <b-input-group-prepend><label>Out</label></b-input-group-prepend>
                    <b-form-select v-model="frmuploadGretDay.timeOut" :plain="true" :options="kolomXls"
                      :state="!$v.frmuploadGretDay.timeOut.$error"></b-form-select>
                  </b-input-group>
                  <b-input-group>
                    <b-input-group-prepend><label>Day Type</label></b-input-group-prepend>
                    <b-form-select v-model="frmuploadGretDay.dayType" :plain="true" :options="kolomXls"
                      :state="!$v.frmuploadGretDay.dayType.$error"></b-form-select>
                  </b-input-group>
                  <b-input-group>
                    <b-input-group-prepend><label>Status</label></b-input-group-prepend>
                    <b-form-select v-model="frmuploadGretDay.tanggal" :plain="true" :options="kolomXls"
                      :state="!$v.frmuploadGretDay.tanggal.$error"></b-form-select>
                  </b-input-group>
                  <b-row no-gutters>
                    <b-col>
                      <b-input-group>
                        <b-input-group-prepend><label>Keterangan</label></b-input-group-prepend>
                        <b-form-select v-model="frmuploadGretDay.uraian" :plain="true" :options="kolomXls"></b-form-select>
                      </b-input-group>
                    </b-col>
                  </b-row>
                  <b-input-group>
                    <b-input-group-prepend><span class="pt-1 mr-1">Download :</span></b-input-group-prepend>
                    <b-link @click="downloadtemplate" class="pt-1 ml-1"><i class="fa fa-paperclip"></i>
                      Template-timesheet.xlsx</b-link>
                  </b-input-group>
                </b-col>
              </b-row>
            </b-card>
            <b-input-group>
              <b-input-group-prepend><label>Choose *.XLSX file</label></b-input-group-prepend>
              <b-form-file v-model="fileXlsx" :state="Boolean(fileXlsx)" placeholder="Choose a XLSX file..."
                drop-placeholder="Drop XLSX file here..."></b-form-file>
            </b-input-group>
            <b-row no-gutters>
              <b-col lg="6">
                <b-input-group>
                  <b-input-group-prepend><label>Nama SHEET </label></b-input-group-prepend>
                  <b-form-input v-model="frmuploadGretDay.sheetName" :state="!$v.frmuploadGretDay.sheetName.$error"></b-form-input>
                </b-input-group>
              </b-col>
              <b-col lg="3">
                <b-input-group>
                  <b-input-group-append><label class="input-group-text ml-1">Data mulai baris
                      ke-</label></b-input-group-append>
                  <b-form-input v-model="frmuploadGretDay.startRow" type="number"
                    :state="!$v.frmuploadGretDay.startRow.$error"></b-form-input>
                </b-input-group>
              </b-col>
            </b-row>
            <!-- <b-row>
              <b-col lg="6">
                <b-input-group>
                  <b-input-group-prepend><label>Period / Month </label></b-input-group-prepend>
                  <vue-monthly-picker style="width:333px;" v-model="frmupload0.periode"
                    :state="!$v.frmupload0.periode.$error" dateFormat="MMMM YYYY"
                    :monthLabels="monthLabels"></vue-monthly-picker>
                </b-input-group>
                <div v-if="($v.frmupload0.periode.$dirty && !$v.frmupload0.periode.$anyError)"
                  style="text-align:right; color:red;">Period / Month is required</div>
              </b-col>
            </b-row> -->
          </b-tab>
        </b-tabs>
      </b-form>
    </b-modal>

    <b-modal v-model="lkuCrewShow" size="lg" :hide-footer="true" title="List of Employee" :centered="true">
      <lku-crew @click="onSelectLkuCrew"></lku-crew>
    </b-modal>
    <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="List of Client/Project" :centered="true">
      <lku-customer @click="onSelectLkuCustomer"></lku-customer>
    </b-modal>

  </div>
</template>

<style lang="scss">
iframe {
  border: 1px solid #ccc;
  width: 100%;
  height: 11in;
}

.ColsDefine {
  .input-group {
    .input-group-prepend {
      label {
        width: 120px !important;
      }
    }
  }
}

.input-group {
  padding-bottom: 2px;

  .input-group-prepend {
    label {
      padding-top: 5px;
      padding-right: 5px;
      width: 120px;
    }
  }
}
</style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import VueMonthlyPicker from 'vue-monthly-picker';
import moment from "moment";
import timesheet from "../../apis/timesheet";
import lkuCrew from "../lookup/lkuCrew";
import lkuCustomer from "../lookup/lkuCustomers";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { Loading, VueMonthlyPicker, lkuCrew, lkuCustomer },
  mixins: [validationMixin],
  validations: {
    model: {
      crewkey: { required },
      tanggal: { required },
      payrolldate: { required },
      HARI_HADIR: { required },
      HARI_IZIN: { required },
      HARI_SAKIT: { required },
      HARI_ALPA: { required },
      HARI_OOT: { required },
      HARI_BKO: { required },
      JAM_KERJA: { required },
      // JAM_OT: { required },
    },
    frmupload0: {
      periode: { required },
      sheetName: { required },
      headerRow: { required },
      startRow: { required },
      crewname: { required },
      crewnik: { required },
      tgl1: { required },
      tgl2: { required },
    },
    frmupload1: {
      periode: { required },
      sheetName: { required },
      startRow: { required },
      crewname: { required },
      crewnik: { required },
      tanggal: { required },
      HARI_HADIR: { required },
      HARI_IZIN: { required },
      HARI_SAKIT: { required },
      HARI_ALPA: { required },
      HARI_BKO: { required },
      HARI_OOT: { required },
      JAM_KERJA: { required },
      JAM_OT: { required },
    },
    frmuploadGretDay: {
        sheetName:{required},
        startRow:{required},
        crewnik:{required},
        crewname:{required},
        jobPosition:{required},
        department:{required},
        tanggal:{required},
        shiftCode:{required},
        shiftStart:{required},
        shiftEnd:{required},
        timeIn:{required},
        timeOut:{required},
        dayType:{required},
        status:{required},
        uraian:{required},
      },
  },
  data() {
    return {
      showFilter: false,
      showDelConfirm: false,
      showUploadFrm: false,
      showForm: false,
      compileShow: false,
      compilePeriode: '',
      lkuCrewShow: false, lkuCustomerShow: false,
      fileXlsx: null,
      tabIndex: 0,
      frmupload0: {
        periode: '',
        sheetName: '',
        headerRow: '',
        startRow: '',
        crewname: '',
        crewnik: '',
        tgl1: '',
        tgl2: '',
      },
      frmupload1: {
        periode: '',
        sheetName: '',
        startRow: '',
        crewname: '',
        crewnik: '',
        tanggal: '',
        HARI_HADIR: '',
        HARI_IZIN: '',
        HARI_SAKIT: '',
        HARI_ALPA: '',
        HARI_OOT: '',
        JAM_OOT: '',
        JAM_OT: '',
      },
      frmuploadGretDay: {
        sheetName: '',
        startRow: '',
        crewnik: 'B',
        crewname: 'C',
        jobPosition:'D',
        department:'E',
        tanggal: 'F',
        shiftCode: 'G',
        shiftStart:'H',
        shiftEnd:'I',
        timeIn:'J',
        timeOut:'K',
        dayType:'L',
        status:'M',
        uraian:'N',
      },

      kolomXls: ['', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
        'AA', 'AB', 'AC', 'AD', 'AE', 'AF', 'AG', 'AH', 'AI', 'AJ', 'AK', 'AL', 'AM', 'AN', 'AO', 'AP', 'AQ', 'AR', 'AS', 'AT', 'AU', 'AV', 'AW', 'AX', 'AY', 'AZ'],
      YesNo: [{ value: 1, text: 'YES' }, { value: 0, text: 'NO' }],
      YesNoAll: [{ value: '', text: '-- ALL --' }, , { value: '1', text: 'Yes' }, { value: '0', text: 'No' }],
      monthLabels: dropdown.monthLabels,
      isLoading: false,
      showReport: false,
      reportUrl: `${location.origin}/#load`,
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        tahunbulan: moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').format('YYYYMM'),
        payrolldate: this.$store.state.user.tglaktif,
        sortBy: 'tanggal',
        sortDesc: false
      },
      tblFields: [
        {
          key: "crewinfo",
          label: "Employee Name",
          sortable: true
        },
        {
          key: "jabatan",
          label: "Job Title",
          sortable: true
        },
        {
          key: "projectname",
          label: "Project Name",
          sortable: true
        },
        {
          key: "locationname",
          label: "Location",
          sortable: true
        },
        {
          key: "payrolldate",
          thStyle: "width:90px",
          label: "Payroll Periode",
          variant: 'warning',
          sortable: true
        },
        {
          key: "tanggal",
          thStyle: "width:90px",
          label: "Working Date",
          sortable: true
        },
        {
          key: "JAM_KERJA",
          thStyle: "width:50px",
          label: "Jam Kerja",
          sortable: true
        },
        {
          key: "HARI_LIBUR",
          thStyle: "width:50px",
          label: "Hari Raya",
          sortable: true
        },
        {
          key: "HARI_HADIR",
          thStyle: "width:50px",
          label: "Hadir",
          sortable: true
        },
        {
          key: "HARI_SAKIT",
          thStyle: "width:50px",
          label: "Sakit",
          sortable: true
        },
        {
          key: "HARI_IZIN",
          thStyle: "width:50px",
          label: "Izin",
          sortable: true
        },
        {
          key: "HARI_ALPA",
          thStyle: "width:50px",
          label: "Alpa(TK)",
          sortable: true
        },
        {
          key: "HARI_OOT",
          label: "OOT",
          sortable: true
        },
        {
          key: "HARI_BKO",
          label: "BKO",
          sortable: true
        },
        {
          key: "JAM_OT",
          thStyle: "width:50px",
          label: "JAM OT",
          sortable: true
        },
        {
          key: "INDEX_OT",
          thStyle: "width:50px",
          label: "INDEX OT",
          sortable: true
        },
        {
          key: "uraian",
          thStyle: "width:400px",
          label: "Description",
          sortable: true
        },
        // {
        //   key: "HARI_MAHAL",
        //   thStyle: "width:50px",
        //   label: "Tj.Kemahalan",
        //   sortable: true
        // },
      ],
      model: { crewkey: '', tanggal: '', HARI_HADIR: 0, HARI_IZIN: 0, HARI_SAKIT: 0, HARI_ALPA: 0, HARI_MAHAL: 0, HARI_OOT: 0, JAM_OOT: 0, JAM_OT: 0, overtimeable: 1, uraian: '', payrolldate: '' },
    };
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidfrmupload0() {
      this.$v.frmupload0.$touch();
      return this.$v.frmupload0.$invalid;
    },
    invalidfrmupload1() {
      this.$v.frmupload1.$touch();
      return this.$v.frmupload1.$invalid;
    },
    invalidfrmuploadgreatday() {
      this.$v.frmuploadGretDay.$touch();
      return this.$v.frmuploadGretDay.$invalid;
    },
    jam_oot() { return this.model.JAM_OOT },
    jam_ot() { return this.model.JAM_OT },
    hari_oot() { return this.model.HARI_OOT },
  },
  watch: {
    jam_ot: function (newval) {
      this.model.INDEX_OT = 0;
      if (Math.floor(newval) > 0) {
        this.model.INDEX_OT = 1.5;
        if (Math.floor(newval) > 1) {
          this.model.INDEX_OT = this.model.INDEX_OT + (2 * (Math.floor(newval) - 1));
        }
      }
    },
    jam_oot: function (newval) {
      this.model.INDEX_OOT = 0;
      if (Math.floor(newval) > 0) {
        this.model.INDEX_OOT = 1.5;
        if (Math.floor(newval) > 1) {
          this.model.INDEX_OOT = this.model.INDEX_OOT + (2 * (Math.floor(newval) - 1));
        }
        this.model.INDEX_OOT = this.model.INDEX_OOT * 2;
      }
    },
    hari_oot: function (newval) {
      if (newval === 1) {
        this.model.HARI_HADIR = 1;
      }
    },
    /**
    'tabIndex': function (newval) {
      if (newval===1) {
        this.frmdata.crewnik = 'A';
        this.frmdata.uraian = 'K';
      } else {
        this.frmdata.crewnik = 'D';
        this.frmdata.uraian = 'AJ';
      }      
    },
     */
  },
  created: async function () {
    const uploadConfig = await timesheet.uploadConfig();
    for (var key in uploadConfig.config) {
      this.frmupload0[key] = uploadConfig.config[key];
    }
    for (var key in uploadConfig.config1) {
      this.frmupload1[key] = uploadConfig.config1[key];
    }
  },
  methods: {
    onSelectLkuCustomer: async function (_selected) {
      this.model.CustName = _selected.CustName.trim() + ' | ' + _selected.CustCode.trim();
      this.model.projectid = _selected.customer_id;
      this.tblData.CustName = _selected.CustName.trim() + ' | ' + _selected.CustCode.trim();
      this.tblData.projectid = _selected.customer_id;
      this.tblData.projectname = _selected.CustName;
      this.lkuCustomerShow = false;
    },
    onSelectLkuCrew: async function (_selected) {
      this.model.crewinfo = _selected.crewname.trim() + ' | ' + _selected.crewnik.trim();
      this.model.crewname = _selected.crewname
      this.model.crewkey = _selected.crewkey
      this.model.overtimeable = _selected.overtimeable
      this.tblData.crewinfo = _selected.crewname.trim() + ' | ' + _selected.crewnik.trim();
      this.tblData.crewname = _selected.crewname
      this.tblData.crewkey = _selected.crewkey
      this.lkuCrewShow = false;
    },
    data: async function () {
      const filter = this.$store.state.filter;
      let filtered = false;
      for (var key in filter.timesheetlist) {
        this.tblData[key] = filter.timesheetlist[key];
        filtered = true;
      }
      if (filtered === true) {
        this.showFilter = filtered;
        delete filter.timesheetlist;
        this.$store.commit("filter", filter);
        // this.$store.commit("filter", {});
      }
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.tblData.tahunbulan = (this.tblData.payrolldate) ? moment(this.tblData.payrolldate).format('YYYYMM') : '';

      this.isLoading = true;
      const list = await timesheet.list(this.tblData);
      this.isLoading = false;

      return list;
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    clearFilter(ctx) {
      this.tblData.crewkey = '';
      this.tblData.crewname = '';
      this.tblData.projectid = '';
      this.tblData.projectname = '';
      this.tblData.locationname = '';
      this.tblData.tgl1 = '';
      this.tblData.tgl2 = '';
      this.tblData.payrolldate = '';
      this.tblData.tahunbulan = '';
      this.$forceUpdate();
    },
    togleFilter() {
      this.showFilter = !this.showFilter;
    },
    handleOk: function (evt) {
      evt.preventDefault()
      if (this.invalidfrmuploadgreatday) {
        console.log('validation : ', this.$v.frmuploadGretDay);
        console.log('frmdata obj : ', this.frmuploadGretDay);
        toastr.error('Please fill the form correctly.', "Error Info");
      } else if (this.fileXlsx) {
        this.showUploadFrm = false;
        // this.$forceUpdate();
        this.uploadinv()
      } else {
        toastr.warn('Please select one File XLSX that want to Upload ');
      }
    },
    downloadtemplate: function () {
      if (this.tabIndex == 0) {
        timesheet.downloadtemplate2();
      } else {
        timesheet.downloadtemplate1();
      }
    },
    uploadinv: async function () {
      if (this.invalidfrmdata) {
        console.log('validation : ', this.$v.frmdata);
        console.log('frmdata obj : ', this.frmdata);
        toastr.error('Please fill the form correctly.', "Error Info");
      } else if (this.fileXlsx) {
        this.showUploadFrm = false;
        this.isLoading = true;
        try {
          if (this.tabIndex == 0) {
            this.frmupload0.payrolldate = moment(this.frmupload0.periode).format('YYYY-MM-DD');
            //  console.log('this.frmupload0.payrolldate : ',this.frmupload0.payrolldate);
            const response = await timesheet.upload2(this.fileXlsx, this.frmupload0);
          } else if(this.tabIndex == 1) {
            this.frmupload1.payrolldate = moment(this.frmupload1.periode).format('YYYY-MM-DD');
            //  console.log('this.frmupload1.payrolldate : ',this.frmupload1.payrolldate);
            const response = await timesheet.upload1(this.fileXlsx, this.frmupload1);
          }else{
            this.frmupload1.payrolldate = moment(this.frmupload1.periode).format('YYYY-MM-DD');
            const response = await timesheet.uploadGreatDay(this.fileXlsx, this.frmuploadGretDay);
          }
          this.isLoading = false;
          // console.log(response); 
        } catch (error) {
          this.isLoading = false;
          this.showUploadFrm = true;
          if (error.sql) {
            toastr.error(error.sql, 'Error Info', 10000);
          } else {
            if (error.message) {
              toastr.error(error.message, 'Error Info', 10000);
            } else {
              toastr.error(JSON.stringify(error), 'Error Info', 10000);
            }
          }
        }
      } else {
        toastr.warn('Please select one File XLSX that want to Upload ');
      }
    },
    add() {
      this.model = { crewkey: '', tanggal: '', HARI_HADIR: 0, HARI_IZIN: 0, HARI_SAKIT: 0, HARI_ALPA: 0, HARI_MAHAL: 0, HARI_BKO: 0, HARI_OOT: 0, JAM_KERJA: 8, JAM_OOT: 0, JAM_OT: 0, overtimeable: 1, uraian: '', payrolldate: this.$store.state.user.tglaktif };
      this.showForm = true;
    },
    edit: function () {
      if (this.model.crewkey) {
        this.model.tanggal = this.model.tanggal ? moment(this.model.tanggal).format('YYYY-MM-DD') : '';
        this.showForm = true;
      } else {
        toastr.warn('Please select a row that want to be Edit!');
      }
    },
    compile: async function (evt) {
      evt.preventDefault()
      if (!(this.compilePeriode)) {
        toastr.error('Please fill the Payroll Periode.', "Error Info");
      } else {
        try {
          this.compileShow = false;
          this.isLoading = true;
          const data = {};
          data.periode = moment(this.compilePeriode).format('YYYY-MM-DD');
          await timesheet.compile(data);
          toastr.success("Process Complete")
          this.isLoading = false;
        } catch (error) {
          // this.isLoading=false;
          if (error.message) {
            toastr.error(error.message, "Error Info", 10000);
          } else {
            toastr.error(JSON.stringify(error), "Error Info", 10000);
          }
        }
      }
    },
    save: async function () {
      if (this.invalidModel) {
        console.log('validation  : ', this.$v.model);
        console.log('model : ', this.model);
        toastr.error('Please fill the form correctly.', "Error Info");
      } else {
        try {
          const data = {};
          for (var key in this.model) {
            data[key] = this.model[key];
          }
          data.tanggal = moment(data.tanggal).format('YYYY-MM-DD');
          data.payrolldate = moment(data.payrolldate).format('YYYY-MM-DD');
          await timesheet.save(data);
          this.showForm = false;
        } catch (error) {
          if (error.message) {
            toastr.error(error.message, "Error Info", 10000);
          } else {
            toastr.error(JSON.stringify(error), "Error Info", 10000);
          }
        }
      }
    },
    deleteConfirm() {
      if (this.model.crewkey) {
        this.showDelConfirm = true;
      } else {
        toastr.warn('Please select a row that want to be Delete!');
      }
    },
    deleteData: async function () {
      await timesheet.remove(this.model);
      this.refresh();
    },
    rowClicked(record, index) {
      // if (this.model.timesheetKey == record.timesheetKey) {
      //     this.edit();
      // } else {
      if ((this.model) && (this.model._rowVariant)) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = 'info';
      this.$forceUpdate();
      // }
    },
    print: async function () {
      if (this.model.crewkey) {
        this.isLoading = true;
        try {
          this.showReport = true;
          this.reportUrl = await timesheet.print(this.model);
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      } else {
        toastr.warn('Please select a row that want to be Printed!');
      }
    },
    exportxls: async function () {
      try {
        const response = await timesheet.exportxls(this.tblData);
      } catch (error) {
        if (error.message) {
          toastr.error(error.message);
        } else {
          toastr.error(JSON.stringify(error));
        }
      }
    },
    close() {
      router.push("/payroll/home");
    },
  }
};
</script>
